import React, { useContext, useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import ExtrasCategorySelect from "components/DropDowns/ExtrasCategorySelect";
import VatSelect from "components/DropDowns/VatSelect";
import ProductSelect from "components/DropDowns/ProductSelect";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

function ExtraPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/extras";
  const history = useHistory();
  const { id } = useParams();
  const { storeId, setStoreId } = useContext(StoreContext);
  const [extraCategoryId, setExtraCategoryId] = useState(null);
  const [inventoryProductId, setInventoryProductId] = useState(null);
  const [extraName, setExtraName] = useState("");
  const [extraFontSize, setExtraFontSize] = useState(13);
  const [extraColor, setExtraColor] = useState("#28c76f");
  const [extraOrder, setExtraOrder] = useState(0);
  const [extraVatId, setExtraVatId] = useState(null);
  const [extraPrice, setExtraPrice] = useState(parseFloat(0).toFixed(2));
  const [extraDeleted, setExtraDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleScroll = (e) => {
    e.target.blur();
  };

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/extras/${id}`)
      .then((extra) => {
        fillFields(extra);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const handleInputNameChange = (e) => {
    setExtraName(e.target.value);
  };

  const handleInputFontSizeChange = (e) => {
    setExtraFontSize(e.target.value);
  };

  const handleExtraCategoryChange = (extraCategoryId) => {
    setExtraCategoryId(extraCategoryId);
  };

  const handleExtraVat = (extraVatId) => {
    setExtraVatId(extraVatId);
  };

  const handleInventoryProduct = (inventoryProductId) => {
    setInventoryProductId(inventoryProductId);
  };

  const handleExtraPriceChange = (event) => {
    const input = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(input)) setExtraPrice(input);
  };

  const save = () => {
    setIsDisabled(true);
    const extra = {
      name: extraName,
      color: extraColor ? extraColor : "ffffff",
      order: extraOrder ? extraOrder : 0,
      fontSize: extraFontSize,
      storeId: storeId,
      inventoryProductId: inventoryProductId,
      extraCategoryId: extraCategoryId,
      price: extraPrice ? extraPrice : 0,
      vatId: extraVatId,
      deleted: extraDeleted,
    };

    if (id) {
      apiService
        .putJson(`api/v1/extras/${id}`, extra)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.extraSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/extras", extra)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.extraCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (extra) => {
    setExtraName(extra.name);
    setExtraFontSize(extra.fontSize);
    setExtraPrice(extra.price.toFixed(2));
    setExtraColor(extra.color);
    setExtraOrder(extra.order);
    setExtraDeleted(extra.deleted);
    setInventoryProductId(extra.inventoryProduct ? extra.inventoryProduct.id : null);
    setExtraCategoryId(extra.extraCategory.id);
    setExtraVatId(extra.vat ? extra.vat.id : null);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editExtra") : t("pages.titles.createExtra")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.name")}</label>
                        <Form.Control
                          placeholder={t("common.labels.name")}
                          required={true}
                          type="text"
                          value={extraName}
                          onChange={handleInputNameChange}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <ExtrasCategorySelect title={t("common.labels.extraCategory")} defaultValue={extraCategoryId} handler={handleExtraCategoryChange} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.price")}</label>
                        <Form.Control
                          placeholder={t("common.labels.price")}
                          required={true}
                          type="number"
                          value={extraPrice}
                          onChange={handleExtraPriceChange}
                          step=".01"
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <VatSelect title={t("tables.headers.vat")} defaultValue={extraVatId} handler={handleExtraVat} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={extraOrder}
                          onChange={(event) => setExtraOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.fontSize")}</label>
                        <Form.Control
                          placeholder={t("common.labels.fontSize")}
                          required={true}
                          type="number"
                          value={extraFontSize}
                          onChange={handleInputFontSizeChange}
                          onWheel={handleScroll}
                          min="0"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={extraColor}
                          onChange={(event) => setExtraColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <ProductSelect title={t("common.labels.inventoryProduct")} defaultValue={inventoryProductId} handler={handleInventoryProduct} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-2" checked={extraDeleted} onChange={(e) => setExtraDeleted(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ExtraPage;
